// LandingPage.js

import "./LandingPage.css";
import { Link, useNavigate } from "react-router-dom";


import React, { useEffect, useState } from "react";
import { FaInstagram } from "react-icons/fa6";
 // Loader state

const LandingPage = () => {
  const [showSecondLogo, setShowSecondLogo] = useState(false);
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSecondLogo(true);
    }, 3000); // 3 seconds for the first logo transition

    return () => clearTimeout(timer);
  }, []);

  const handleRegister = () => {
    navigation("/login")
  }

  return (
    <div className="landing-page">
      {/* <div className="landing-page-logo-container">
        <img
          src="./assets/riyway.jpeg" // Replace with the path to your logo image
          alt="Logo"
          className="landing-page-logo"
        />
      </div>
      <nav className="landing-page-menu">
        <ul className="landing-page-menu-items">
          <li className="landing-page-menu-item">NEW FEED</li>
          <li className="landing-page-menu-item">COLLECTIONS</li>
          <li className="landing-page-menu-item">CONTACT US</li>
          <li className="landing-page-menu-item">ALL PRODUCTS</li>
          <Link to="/login"><li className="landing-page-menu-item">LOGIN</li></Link>
        </ul>
      </nav>
      <div className="landing-page-footer-icon">
        <FaInstagram className="landing-page-insta-logo" />
      </div> */}

      <div className="landing-page-logo-container">
        {!showSecondLogo && (
          <img src="./assets/offwhitery.png" alt="First Logo" className="landing-page-logo fade-up" />
        )}


        {showSecondLogo && (
          <div className="landing-page-second-phase">
            <img src="./assets/offwhitery.png" alt="Second Logo" className="landing-page-logo1 fade-up" />
            <div className="landing-page-left">
          <div className="landing-page-item">Collections</div>
          <div className="landing-page-item" onClick={() => navigation("/home")}>
            Products
          </div>
        </div>
            {/* <p className="landing-page-para">All Registered Members will unlock Exclusive 40% discount as soon as the pre-launch sale kicks-off don't miss this opportunity to save big!</p> */}
            <button className="landing-page-register-button" onClick={handleRegister}>Login</button>
          </div>
        )}
      </div>

    </div>
  );
};

export default LandingPage;
